export default {"src":"/_next/static/media/costa-rica.45bbd708.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};